import apiService from 'src/enviroment'

export const postBuscadorService = async (body) => {
  try {
    const response = await apiService.post('ia/buscador/', body)
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

export const postLinkActionService = async (body) => {
  try {
    const response = await apiService.post('ia/buscador/link', body)
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}
